module.exports = __webpack_public_path__ + "img/2-7964.230ab9b0.png";